import { Feather } from "@expo/vector-icons";
import { of } from "@nozbe/watermelondb/utils/rx";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { SaleAdjustmentType } from "@towersystems/roam-common/lib/generated-types";
import React from "react";
import { Colors } from "react-native-ui-lib";
import { compose } from "recompose";
import { Text } from "@towersystems/roam-common-native";
import Sale from "../../../../../../utilities/data/model/Sale";
import { moneyToFormattedString } from "../../../../../../utilities/money";
import { withSaleController } from "../../../../utils/sale-controller";
import { QuickKey as BaseQuickKey, QuickKeyProps } from "../../../QuickKey";
import { LoyaltyValue } from "../../components/CustomerLoyaltyPointsQuickKey/components/LoyaltyValue";
import { CustomerPoints } from "./components";

const getObserables = ({ sale }: { sale: Sale }) => ({
  items: sale ? sale.items.observeWithColumns(["adjustments"]) : of([]),
});

type CustomerLoyaltyPointsQuickKeyRendererProps = ExtractedObservables<
  ReturnType<typeof getObserables>
> & {
  sale?: Sale;
} & QuickKeyProps;

export const CustomerLoyaltyPointsQuickKeyRenderer = React.forwardRef<
  any,
  CustomerLoyaltyPointsQuickKeyRendererProps
>(({ sale, items, disabled: _disabled, ...rest }, ref) => {
  const isDisabled =
    _disabled !== undefined ? _disabled : !sale || !sale.customer.id;

  const isRemoveDiscount = items?.some((item) =>
    item.adjustments.find((i) => i.type === SaleAdjustmentType.LOYALTY_DISCOUNT)
  );

  const adjustmentTotal = items?.reduce((acc, item) => {
    const adjustment = item.adjustments.find(
        (i) => i.type === SaleAdjustmentType.LOYALTY_DISCOUNT
      ),
      adjustmentTotal = adjustment ? adjustment.amount * item.quantity : 0;

    return acc + adjustmentTotal;
  }, 0);

  const subTitle = isRemoveDiscount
    ? `Remove ${moneyToFormattedString(adjustmentTotal)}`
    : "";

  const loyaltyValueMarkup =
    isDisabled || isRemoveDiscount ? null : <LoyaltyValue sale={sale} />;

  const label =
    sale && !isDisabled ? (
      isRemoveDiscount ? (
        <Text>Remove Loyalty Discount</Text>
      ) : (
        <CustomerPoints sale={sale} />
      )
    ) : null;

  const subTextColor = isDisabled
    ? Colors.white
    : isRemoveDiscount
    ? Colors.quickKeyDestructionText
    : Colors.quickKeyModiferText;

  return (
    <BaseQuickKey
      ref={ref}
      isDestructive={isRemoveDiscount}
      disabled={isDisabled}
      backgroundColor={Colors.quickKeyModifer}
      iconPrimary={<Feather name="star" size={24} color={subTextColor} />}
      label={isRemoveDiscount ? "Remove Loyalty Discount" : "Loyalty Discount"}
      labelComponent={!isRemoveDiscount && label}
      subtitle={subTitle}
      subtitleComponent={loyaltyValueMarkup}
      subtitleStyle={{ color: subTextColor, opacity: 1 }}
      onPress={() =>
        isRemoveDiscount
          ? sale?.removeLoyaltyDiscount().catch((e) => console.log(e))
          : sale?.applyCustomerLoyaltyPoints().catch((err) => console.log(err))
      }
      isModifier
      {...rest}
    ></BaseQuickKey>
  );
});

export const CustomerLoyaltyPointsQuickKey = compose(
  withSaleController,
  withObservables(["sale"], getObserables)
  //@ts-ignore
)(CustomerLoyaltyPointsQuickKeyRenderer);
